module.exports = "<p>products works!</p>\n"